import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b12e0b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wageBeforeAfterModalCard" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "비과세 적용 전후 비교표", -1))
const _hoisted_4 = { class: "info-section" }
const _hoisted_5 = { class: "info-row" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "조회 연월", -1))
const _hoisted_8 = { class: "info-value highlight" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "서비스 시작연월", -1))
const _hoisted_11 = { class: "info-value" }
const _hoisted_12 = { class: "action-section" }
const _hoisted_13 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit-label" }, "단위: 원", -1))
const _hoisted_15 = { class: "comparison-table-wrapper" }
const _hoisted_16 = { class: "comparison-table" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "sticky-col col-no"
}, "No", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "sticky-col-name"
}, "사원명", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "직종", -1))
const _hoisted_20 = {
  key: 0,
  rowspan: "2",
  class: "retired-header"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "총급여", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "before-header"
}, "개선전", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "after-header"
}, "개선후", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "diff-header"
}, "차액", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "saving-header"
}, "절감액", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "before-header" }, "비과세"),
  /*#__PURE__*/_createElementVNode("th", { class: "before-header" }, "기관부담"),
  /*#__PURE__*/_createElementVNode("th", { class: "before-header" }, "퇴직금"),
  /*#__PURE__*/_createElementVNode("th", { class: "before-header" }, "지급급여"),
  /*#__PURE__*/_createElementVNode("th", { class: "after-header" }, "비과세"),
  /*#__PURE__*/_createElementVNode("th", { class: "after-header" }, "기관부담"),
  /*#__PURE__*/_createElementVNode("th", { class: "after-header" }, "퇴직금"),
  /*#__PURE__*/_createElementVNode("th", { class: "after-header" }, "지급급여"),
  /*#__PURE__*/_createElementVNode("th", { class: "diff-sub-header" }, "비과세"),
  /*#__PURE__*/_createElementVNode("th", { class: "diff-sub-header" }, "기관부담"),
  /*#__PURE__*/_createElementVNode("th", { class: "diff-sub-header" }, "퇴직금"),
  /*#__PURE__*/_createElementVNode("th", { class: "diff-sub-header" }, "지급급여")
], -1))
const _hoisted_27 = { class: "sticky-col col-no text-center" }
const _hoisted_28 = { class: "sticky-col-name" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = {
  key: 0,
  class: "text-center retired-cell"
}
const _hoisted_31 = ["checked", "onChange"]
const _hoisted_32 = ["title"]
const _hoisted_33 = ["title"]
const _hoisted_34 = ["title"]
const _hoisted_35 = ["title"]
const _hoisted_36 = ["title"]
const _hoisted_37 = ["title"]
const _hoisted_38 = ["title"]
const _hoisted_39 = ["title"]
const _hoisted_40 = ["title"]
const _hoisted_41 = ["title"]
const _hoisted_42 = ["title"]
const _hoisted_43 = ["title"]
const _hoisted_44 = ["title"]
const _hoisted_45 = ["title"]
const _hoisted_46 = { class: "total-row" }
const _hoisted_47 = ["colspan"]
const _hoisted_48 = { class: "text-right font-bold" }
const _hoisted_49 = { class: "before-cell text-right font-bold" }
const _hoisted_50 = { class: "before-cell text-right font-bold" }
const _hoisted_51 = { class: "before-cell text-right font-bold" }
const _hoisted_52 = { class: "before-cell text-right font-bold" }
const _hoisted_53 = { class: "after-cell text-right font-bold" }
const _hoisted_54 = { class: "after-cell text-right font-bold" }
const _hoisted_55 = { class: "after-cell text-right font-bold" }
const _hoisted_56 = { class: "after-cell text-right font-bold" }
const _hoisted_57 = { class: "summary-section" }
const _hoisted_58 = { class: "summary-cards" }
const _hoisted_59 = { class: "summary-card before-card" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "개선전 (생산직비과세 미적용)", -1))
const _hoisted_61 = { class: "summary-row" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "총급여", -1))
const _hoisted_63 = { class: "value" }
const _hoisted_64 = { class: "summary-row" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "비과세", -1))
const _hoisted_66 = { class: "value" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_68 = { class: "summary-row" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "기관부담 4대보험", -1))
const _hoisted_70 = { class: "value" }
const _hoisted_71 = { class: "summary-row" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "퇴직금", -1))
const _hoisted_73 = { class: "value" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_75 = { class: "summary-row total" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "지급급여 (실수령액)", -1))
const _hoisted_77 = { class: "value" }
const _hoisted_78 = { class: "summary-card after-card" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "개선후 (생산직비과세 적용)", -1))
const _hoisted_80 = { class: "summary-row" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "총급여", -1))
const _hoisted_82 = { class: "value" }
const _hoisted_83 = { class: "summary-row" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "비과세", -1))
const _hoisted_85 = { class: "value" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_87 = { class: "summary-row" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "기관부담 4대보험", -1))
const _hoisted_89 = { class: "value" }
const _hoisted_90 = { class: "summary-row" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "퇴직금", -1))
const _hoisted_92 = { class: "value" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_94 = { class: "summary-row total" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "지급급여 (실수령액)", -1))
const _hoisted_96 = { class: "value" }
const _hoisted_97 = { class: "summary-card diff-card" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "기관 비용 절감 효과", -1))
const _hoisted_99 = { class: "summary-row highlight-row" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "대상 인원", -1))
const _hoisted_101 = { class: "value" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_103 = { class: "summary-row" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "기관부담 4대보험 차액", -1))
const _hoisted_105 = { class: "summary-row" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "퇴직금 차액", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_108 = { class: "summary-row total" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "월 절감액", -1))
const _hoisted_110 = { class: "summary-row info" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 절감 예상액", -1))
const _hoisted_112 = {
  key: 1,
  class: "modal-content empty-state"
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "데이터가 없습니다.", -1))
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = { class: "modal-footer" }

import { ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import WageBeforeAfterHelp from "./WageBeforeAfterHelp.vue";

interface ComparisonItem {
  empName: string;
  empJob: string;
  total: string;
  before: { nonTax: string; companyIns: string; retirement: string; netPay: string };
  after: { nonTax: string; companyIns: string; retirement: string; netPay: string };
  diff: { nonTax: string; companyIns: string; retirement: string; netPay: string };
  saving: string;
  tooltip: {
    total: string;
    beforeNonTax: string; beforeCompanyIns: string; beforeRetirement: string; beforeNetPay: string;
    afterNonTax: string; afterCompanyIns: string; afterRetirement: string; afterNetPay: string;
    diffNonTax: string; diffCompanyIns: string; diffRetirement: string; diffNetPay: string;
    saving: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WageExcelBeforeAfter',
  props: {
    excelData: {},
    calcData: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const store = useStore();
const dialog = ref(false);
const activeTab = ref("detail");
const comparisonData = ref<ComparisonItem[]>([]);

// 서비스 시작연월 관련
const serviceStartDate = ref<string>("");
const rawServiceStartYm = ref<string>(""); // YYYY-MM 형식
const isEditingServiceDate = ref(false);
const editServiceDate = ref("");
const isSavingDate = ref(false);
const currentYearMonth = ref("");
const rawCurrentYm = ref<string>(""); // YYYY-MM 형식

// 퇴사자 선택 관련 (서비스 시작 이전 퇴사자 선택용)
const retiredSet = ref<Set<string>>(new Set());
const hasServiceStartYm = ref(false); // 서비스 시작연월이 설정되어 있는지
const allComparisonData = ref<ComparisonItem[]>([]); // 필터링 전 전체 데이터
const hideRetired = ref(false); // 제외된 인원 숨기기 토글

// 퇴사자 제외한 실제 인원수
const activeEmployeeCount = computed(() => {
  return allComparisonData.value.filter(item => !retiredSet.value.has(item.empName)).length;
});

// 화면에 표시할 데이터 (퇴사자 숨기기 적용)
const displayComparisonData = computed(() => {
  if (hideRetired.value) {
    return comparisonData.value.filter(item => !retiredSet.value.has(item.empName));
  }
  return comparisonData.value;
});

const totals = reactive({
  total: "0",
  before: { nonTax: "0", companyIns: "0", retirement: "0", netPay: "0" },
  after: { nonTax: "0", companyIns: "0", retirement: "0", netPay: "0" },
  diff: { nonTax: "0", companyIns: "0", retirement: "0", netPay: "0" },
  saving: "0",
  yearSaving: "0"
});

const nc = (value: any): number => {
  if (value == null) return 0;
  return parseFloat(String(value).replace(/,/g, "")) || 0;
};

const ac = (number: number): string => {
  if (number === 0) return "0";
  return Math.round(number).toLocaleString();
};

const formatYearMonth = (ym: string): string => {
  if (!ym) return "";
  const parts = ym.split("-");
  if (parts.length === 2) {
    return `${parts[0]}년 ${parseInt(parts[1], 10)}월`;
  }
  return ym;
};

const fetchServiceStartDate = async () => {
  try {
    const sisulId = store.state.AdminSisulId;
    const response = await axios.get(`/api/readSsId/${sisulId}`);
    if (response.data?.result) {
      const wageIn = response.data.result.sisul_wage_in;
      serviceStartDate.value = wageIn ? formatYearMonth(wageIn) : "";
      rawServiceStartYm.value = wageIn || "";
      editServiceDate.value = wageIn || "";
    }
  } catch (error) {
    console.error("서비스 시작연월 조회 실패:", error);
  }
};

const saveServiceDate = async () => {
  if (!editServiceDate.value) return;
  isSavingDate.value = true;
  try {
    const sisulId = store.state.AdminSisulId;
    await axios.post("/api/updateSsWageIn", {
      sisul_id: sisulId,
      sisul_wage_in: editServiceDate.value
    });
    serviceStartDate.value = formatYearMonth(editServiceDate.value);
    rawServiceStartYm.value = editServiceDate.value;
    isEditingServiceDate.value = false;
    store.commit("showSnackbar", { text: "서비스 시작연월이 저장되었습니다.", color: "success" });
    updateHasServiceStartYm();
    retiredSet.value = new Set(); // 서비스시작월 변경시 제외 인원 초기화
    calculateComparison();
  } catch (error) {
    console.error("서비스 시작연월 저장 실패:", error);
    store.commit("showSnackbar", { text: "저장 중 오류가 발생했습니다.", color: "error" });
  } finally {
    isSavingDate.value = false;
  }
};

const cancelEditServiceDate = () => {
  isEditingServiceDate.value = false;
};

const toggleRetired = (empName: string) => {
  if (retiredSet.value.has(empName)) {
    retiredSet.value.delete(empName);
  } else {
    retiredSet.value.add(empName);
  }
  retiredSet.value = new Set(retiredSet.value);
  recalculateTotals();
};

const updateHasServiceStartYm = () => {
  hasServiceStartYm.value = !!rawServiceStartYm.value;
};

const openDialog = async () => {
  dialog.value = true;
  rawCurrentYm.value = store.state.AdminYYMM;
  currentYearMonth.value = formatYearMonth(store.state.AdminYYMM);
  retiredSet.value = new Set();
  hideRetired.value = false;
  await fetchServiceStartDate();
  updateHasServiceStartYm();
  calculateComparison();
};

const closeDialog = () => {
  dialog.value = false;
};

const getDiffClass = (value: string, isReverse = false) => {
  const numValue = nc(value);
  if (numValue === 0) return "";
  if (isReverse) {
    return numValue < 0 ? "positive-diff" : "negative-diff";
  }
  return numValue > 0 ? "positive-diff" : "negative-diff";
};

const recalculateTotals = () => {
  const sum = { total: 0 };
  const sumBefore = { nonTax: 0, companyIns: 0, retirement: 0, netPay: 0 };
  const sumAfter = { nonTax: 0, companyIns: 0, retirement: 0, netPay: 0 };

  // 퇴사자 체크된 사원 제외하고 합계 계산
  const activeData = allComparisonData.value.filter(item => !retiredSet.value.has(item.empName));

  activeData.forEach(item => {
    sum.total += nc(item.total);
    sumBefore.nonTax += nc(item.before.nonTax);
    sumBefore.companyIns += nc(item.before.companyIns);
    sumBefore.retirement += nc(item.before.retirement);
    sumBefore.netPay += nc(item.before.netPay);
    sumAfter.nonTax += nc(item.after.nonTax);
    sumAfter.companyIns += nc(item.after.companyIns);
    sumAfter.retirement += nc(item.after.retirement);
    sumAfter.netPay += nc(item.after.netPay);
  });

  totals.total = ac(sum.total);
  totals.before.nonTax = ac(sumBefore.nonTax);
  totals.before.companyIns = ac(sumBefore.companyIns);
  totals.before.retirement = ac(sumBefore.retirement);
  totals.before.netPay = ac(sumBefore.netPay);
  totals.after.nonTax = ac(sumAfter.nonTax);
  totals.after.companyIns = ac(sumAfter.companyIns);
  totals.after.retirement = ac(sumAfter.retirement);
  totals.after.netPay = ac(sumAfter.netPay);
  totals.diff.nonTax = ac(sumAfter.nonTax - sumBefore.nonTax);
  totals.diff.companyIns = ac(sumAfter.companyIns - sumBefore.companyIns);
  totals.diff.retirement = ac(sumAfter.retirement - sumBefore.retirement);
  totals.diff.netPay = ac(sumAfter.netPay - sumBefore.netPay);
  totals.saving = ac((sumAfter.companyIns - sumBefore.companyIns) + (sumAfter.retirement - sumBefore.retirement));
  totals.yearSaving = ac(((sumAfter.companyIns - sumBefore.companyIns) + (sumAfter.retirement - sumBefore.retirement)) * 12);

  // 화면에 표시되는 comparisonData는 전체 데이터 (필터링 없이)
  comparisonData.value = allComparisonData.value;
};

const calculateComparison = () => {
  if (!props.calcData || props.calcData.length === 0) return;

  allComparisonData.value = props.calcData.map((calc: any) => {
    const excel = props.excelData.find((e) => e.empName === calc.empName);

    const total = nc(calc.total);

    // 개선후 (calcData - 생산직비과세 적용)
    const afterTaxable = nc(calc.taxable);
    const afterNonTax = total - afterTaxable;
    const afterDeduction = nc(calc.l_total);
    const afterNetPay = total - afterDeduction;
    const afterRetirement = nc(calc.c_out);

    const after_c_yeon = nc(calc.c_yeon);
    const after_c_gun = nc(calc.c_gun);
    const after_c_jang = nc(calc.c_jang);
    const after_c_go = nc(calc.c_go);
    const after_c_sil = nc(calc.c_sil);
    const after_c_san = nc(calc.c_san);
    const afterCompanyIns = after_c_yeon + after_c_gun + after_c_jang + after_c_go + after_c_sil + after_c_san;

    // 개선후 비과세 항목
    const afterDang = nc(calc.dang);
    const afterLunch = nc(calc.lunch);
    const afterCar = nc(calc.car);
    const afterChildcare = nc(calc.childcare);
    const afterProductionNonTax = afterNonTax - afterDang - afterLunch - afterCar - afterChildcare;

    // 개선전 (excelData 기반 - 생산직비과세 미적용)
    let beforeNonTax = 0;
    let beforeTaxable = 0;
    let beforeCompanyIns = 0;
    let beforeRetirement = 0;
    let beforeNetPay = 0;
    let beforeDeduction = afterDeduction;

    let beforeDang = 0, beforeLunch = 0, beforeCar = 0, beforeChildcare = 0;
    let before_c_yeon = 0, before_c_gun = 0, before_c_jang = 0, before_c_go = 0, before_c_sil = 0, before_c_san = 0;

    if (excel) {
      beforeDang = nc(excel.dang);
      beforeLunch = nc(excel.lunch);
      beforeCar = nc(excel.car);
      beforeChildcare = nc(excel.childcare);

      // 개선전 비과세 (생산직비과세 미적용)
      beforeNonTax = Math.floor((beforeDang + beforeLunch + beforeCar + beforeChildcare) / 10) * 10;
      beforeTaxable = Math.floor((total - beforeNonTax) / 10) * 10;

      beforeNetPay = total - beforeDeduction;

      // 개선전 기관부담 (과세금액 기준으로 계산)
      before_c_yeon = after_c_yeon; // 국민연금은 동일
      before_c_san = after_c_san; // 산재보험은 동일

      // 과세금액 비율로 기관부담 계산
      if (afterTaxable > 0) {
        before_c_gun = after_c_gun === 0 ? 0 : Math.floor((beforeTaxable * (after_c_gun / afterTaxable)) / 10) * 10;
        before_c_jang = (after_c_jang === 0 || after_c_gun === 0) ? 0 : Math.floor((before_c_gun * (after_c_jang / after_c_gun)) / 10) * 10;
        before_c_go = after_c_go === 0 ? 0 : Math.floor((beforeTaxable * (after_c_go / afterTaxable)) / 10) * 10;
        before_c_sil = after_c_sil === 0 ? 0 : Math.floor((beforeTaxable * (after_c_sil / afterTaxable)) / 10) * 10;
      }

      beforeCompanyIns = before_c_yeon + before_c_gun + before_c_jang + before_c_go + before_c_sil + before_c_san;

      // 개선전 퇴직금
      beforeRetirement = afterRetirement === 0 ? 0 : Math.floor(((total - beforeLunch) / 12) / 10) * 10;
    }

    // 차액 계산
    const diffNonTax = afterNonTax - beforeNonTax;
    const diffCompanyIns = afterCompanyIns - beforeCompanyIns;
    const diffRetirement = afterRetirement - beforeRetirement;
    const diffNetPay = afterNetPay - beforeNetPay;
    const saving = diffCompanyIns + diffRetirement;

    // 툴팁 생성
    const tooltipTotal = `[총급여]\n= ${ac(total)}`;

    const tooltipBeforeNonTax = `[개선전 비과세]\n\n` +
      `※ 생산직비과세 미적용\n\n` +
      `◆ 비과세 항목\n` +
      `  당직수당: ${ac(beforeDang)}\n` +
      `  중식대: ${ac(beforeLunch)}\n` +
      `  차량비: ${ac(beforeCar)}\n` +
      `  양육비: ${ac(beforeChildcare)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 비과세 합계: ${ac(beforeNonTax)}`;

    const tooltipBeforeCompanyIns = `[개선전 기관부담 4대보험]\n\n` +
      `◆ 엑셀업로드 데이터 기준\n\n` +
      `  국민연금: ${ac(before_c_yeon)}\n` +
      `  건강보험: ${ac(before_c_gun)}\n` +
      `  장기요양: ${ac(before_c_jang)}\n` +
      `  고용보험: ${ac(before_c_go)}\n` +
      `  실업급여: ${ac(before_c_sil)}\n` +
      `  산재보험: ${ac(before_c_san)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 기관부담 합계: ${ac(beforeCompanyIns)}`;

    const tooltipBeforeRetirement = `[개선전 퇴직금]\n\n` +
      `◆ 계산식\n  (총급여 - 중식대) ÷ 12\n\n` +
      `◆ 산출내역\n` +
      `  총급여: ${ac(total)}\n` +
      `  (-) 중식대: ${ac(beforeLunch)}\n` +
      `  = ${ac(total - beforeLunch)} ÷ 12\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 퇴직금: ${ac(beforeRetirement)}`;

    const tooltipBeforeNetPay = `[개선전 지급급여]\n\n` +
      `◆ 총급여 - 근로자공제\n` +
      `  ${ac(total)} - ${ac(beforeDeduction)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 지급급여: ${ac(beforeNetPay)}`;

    const tooltipAfterNonTax = `[개선후 비과세]\n\n` +
      `※ 생산직비과세 적용\n\n` +
      `◆ 비과세 항목\n` +
      `  생산직비과세: ${ac(afterProductionNonTax)}\n` +
      `  당직수당: ${ac(afterDang)}\n` +
      `  중식대: ${ac(afterLunch)}\n` +
      `  차량비: ${ac(afterCar)}\n` +
      `  양육비: ${ac(afterChildcare)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 비과세 합계: ${ac(afterNonTax)}`;

    const tooltipAfterCompanyIns = `[개선후 기관부담 4대보험]\n\n` +
      `◆ 과세금액 ${ac(afterTaxable)} 기준\n\n` +
      `  국민연금: ${ac(after_c_yeon)}\n` +
      `  건강보험: ${ac(after_c_gun)}\n` +
      `  장기요양: ${ac(after_c_jang)}\n` +
      `  고용보험: ${ac(after_c_go)}\n` +
      `  실업급여: ${ac(after_c_sil)}\n` +
      `  산재보험: ${ac(after_c_san)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 기관부담 합계: ${ac(afterCompanyIns)}`;

    const tooltipAfterRetirement = `[개선후 퇴직금]\n\n` +
      `◆ 계산된 퇴직금\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 퇴직금: ${ac(afterRetirement)}`;

    const tooltipAfterNetPay = `[개선후 지급급여]\n\n` +
      `◆ 총급여 - 근로자공제\n` +
      `  ${ac(total)} - ${ac(afterDeduction)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 지급급여: ${ac(afterNetPay)}`;

    const tooltipDiffNonTax = `[비과세 차액]\n\n` +
      `◆ 개선후 - 개선전\n` +
      `  ${ac(afterNonTax)} - ${ac(beforeNonTax)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 차액: ${ac(diffNonTax)}`;

    const tooltipDiffCompanyIns = `[기관부담 차액]\n\n` +
      `◆ 개선후 - 개선전\n\n` +
      `  국민연금: ${ac(after_c_yeon - before_c_yeon)}\n` +
      `  건강보험: ${ac(after_c_gun - before_c_gun)}\n` +
      `  장기요양: ${ac(after_c_jang - before_c_jang)}\n` +
      `  고용보험: ${ac(after_c_go - before_c_go)}\n` +
      `  실업급여: ${ac(after_c_sil - before_c_sil)}\n` +
      `  산재보험: ${ac(after_c_san - before_c_san)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 차액: ${ac(diffCompanyIns)}`;

    const tooltipDiffRetirement = `[퇴직금 차액]\n\n` +
      `◆ 개선후 - 개선전\n` +
      `  ${ac(afterRetirement)} - ${ac(beforeRetirement)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 차액: ${ac(diffRetirement)}`;

    const tooltipDiffNetPay = `[지급급여 차액]\n\n` +
      `◆ 개선후 - 개선전\n` +
      `  ${ac(afterNetPay)} - ${ac(beforeNetPay)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 차액: ${ac(diffNetPay)}`;

    const tooltipSaving = `[기관 절감액]\n\n` +
      `◆ 기관부담 차액 + 퇴직금 차액\n` +
      `  ${ac(diffCompanyIns)} + ${ac(diffRetirement)}\n` +
      `━━━━━━━━━━━━━━━━━━━━\n` +
      `= 절감액: ${ac(saving)}`;

    return {
      empName: calc.empName,
      empJob: calc.empJob || "",
      total: ac(total),
      before: {
        nonTax: ac(beforeNonTax),
        companyIns: ac(beforeCompanyIns),
        retirement: ac(beforeRetirement),
        netPay: ac(beforeNetPay)
      },
      after: {
        nonTax: ac(afterNonTax),
        companyIns: ac(afterCompanyIns),
        retirement: ac(afterRetirement),
        netPay: ac(afterNetPay)
      },
      diff: {
        nonTax: ac(diffNonTax),
        companyIns: ac(diffCompanyIns),
        retirement: ac(diffRetirement),
        netPay: ac(diffNetPay)
      },
      saving: ac(saving),
      tooltip: {
        total: tooltipTotal,
        beforeNonTax: tooltipBeforeNonTax,
        beforeCompanyIns: tooltipBeforeCompanyIns,
        beforeRetirement: tooltipBeforeRetirement,
        beforeNetPay: tooltipBeforeNetPay,
        afterNonTax: tooltipAfterNonTax,
        afterCompanyIns: tooltipAfterCompanyIns,
        afterRetirement: tooltipAfterRetirement,
        afterNetPay: tooltipAfterNetPay,
        diffNonTax: tooltipDiffNonTax,
        diffCompanyIns: tooltipDiffCompanyIns,
        diffRetirement: tooltipDiffRetirement,
        diffNetPay: tooltipDiffNetPay,
        saving: tooltipSaving
      }
    };
  });

  recalculateTotals();
};

const generatePdf = async () => {
  try {
    const response = await axios.post(
      "/api/getWageBeforeAfterPdf",
      {
        comparisonData: comparisonData.value,
        totals: { total: totals.total, before: totals.before, after: totals.after, diff: totals.diff, saving: totals.saving, yearSaving: totals.yearSaving },
        sisulName: store.state.AdminSisulName,
        yearMonth: store.state.AdminYYMM
      },
      { responseType: "json" }
    );

    const pdfBase64 = response.data.pdf;
    const binaryString = window.atob(pdfBase64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    }
  } catch (error) {
    console.error("PDF 생성 실패:", error);
    store.commit("showSnackbar", {
      text: "PDF 생성 중 오류가 발생했습니다.",
      color: "error"
    });
  }
};

__expose({ dialog, closeDialog, openDialog });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialog).value = $event)),
    "max-width": "1400px",
    class: "fontNotoSans400",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_v_icon, {
            class: "close-btn",
            color: "#333",
            onClick: closeDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-close")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(currentYearMonth.value), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              (!isEditingServiceDate.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(serviceStartDate.value || '미설정'), 1),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      size: "x-small",
                      color: "grey",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (isEditingServiceDate.value = true)),
                      class: "edit-btn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "small" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-pencil")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "month",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editServiceDate).value = $event)),
                      class: "date-input"
                    }, null, 512), [
                      [_vModelText, editServiceDate.value]
                    ]),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      size: "x-small",
                      color: "primary",
                      onClick: saveServiceDate,
                      loading: isSavingDate.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "small" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-check")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      size: "x-small",
                      color: "grey",
                      onClick: cancelEditServiceDate
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "small" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-close")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_v_btn, {
            class: "btnColorDark",
            onClick: generatePdf,
            disabled: comparisonData.value.length === 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("PDF 생성")
            ]),
            _: 1
          }, 8, ["disabled"]),
          (hasServiceStartYm.value && retiredSet.value.size > 0)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: _normalizeClass(hideRetired.value ? 'btnColorOrange' : 'btnColorGrey'),
                size: "small",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (hideRetired.value = !hideRetired.value))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "small",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(hideRetired.value ? 'mdi-eye' : 'mdi-eye-off'), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" 제외된 인원 " + _toDisplayString(hideRetired.value ? '보기' : '숨기기') + " (" + _toDisplayString(retiredSet.value.size) + "명) ", 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(WageBeforeAfterHelp),
        (comparisonData.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_v_tabs, {
                modelValue: activeTab.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeTab).value = $event)),
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tab, { value: "detail" }, {
                    default: _withCtx(() => [
                      _createTextVNode("상세 비교")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, { value: "summary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("요약")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_window, {
                modelValue: activeTab.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeTab).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: "detail" }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("table", _hoisted_16, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_17,
                              _hoisted_18,
                              _hoisted_19,
                              (hasServiceStartYm.value)
                                ? (_openBlock(), _createElementBlock("th", _hoisted_20, "제외"))
                                : _createCommentVNode("", true),
                              _hoisted_21,
                              _hoisted_22,
                              _hoisted_23,
                              _hoisted_24,
                              _hoisted_25
                            ]),
                            _hoisted_26
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayComparisonData.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: item.empName,
                                class: _normalizeClass({ 'retired-row': retiredSet.value.has(item.empName) })
                              }, [
                                _createElementVNode("td", _hoisted_27, _toDisplayString(index + 1), 1),
                                _createElementVNode("td", _hoisted_28, _toDisplayString(item.empName), 1),
                                _createElementVNode("td", _hoisted_29, _toDisplayString(item.empJob), 1),
                                (hasServiceStartYm.value)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: retiredSet.value.has(item.empName),
                                        onChange: ($event: any) => (toggleRetired(item.empName)),
                                        title: "서비스 시작 이전 퇴사자 체크"
                                      }, null, 40, _hoisted_31)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", {
                                  class: "text-right tooltip-cell",
                                  title: item.tooltip.total
                                }, _toDisplayString(item.total), 9, _hoisted_32),
                                _createElementVNode("td", {
                                  class: "before-cell text-right tooltip-cell",
                                  title: item.tooltip.beforeNonTax
                                }, _toDisplayString(item.before.nonTax), 9, _hoisted_33),
                                _createElementVNode("td", {
                                  class: "before-cell text-right tooltip-cell",
                                  title: item.tooltip.beforeCompanyIns
                                }, _toDisplayString(item.before.companyIns), 9, _hoisted_34),
                                _createElementVNode("td", {
                                  class: "before-cell text-right tooltip-cell",
                                  title: item.tooltip.beforeRetirement
                                }, _toDisplayString(item.before.retirement), 9, _hoisted_35),
                                _createElementVNode("td", {
                                  class: "before-cell text-right tooltip-cell",
                                  title: item.tooltip.beforeNetPay
                                }, _toDisplayString(item.before.netPay), 9, _hoisted_36),
                                _createElementVNode("td", {
                                  class: "after-cell text-right tooltip-cell",
                                  title: item.tooltip.afterNonTax
                                }, _toDisplayString(item.after.nonTax), 9, _hoisted_37),
                                _createElementVNode("td", {
                                  class: "after-cell text-right tooltip-cell",
                                  title: item.tooltip.afterCompanyIns
                                }, _toDisplayString(item.after.companyIns), 9, _hoisted_38),
                                _createElementVNode("td", {
                                  class: "after-cell text-right tooltip-cell",
                                  title: item.tooltip.afterRetirement
                                }, _toDisplayString(item.after.retirement), 9, _hoisted_39),
                                _createElementVNode("td", {
                                  class: "after-cell text-right tooltip-cell",
                                  title: item.tooltip.afterNetPay
                                }, _toDisplayString(item.after.netPay), 9, _hoisted_40),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right tooltip-cell", getDiffClass(item.diff.nonTax)]),
                                  title: item.tooltip.diffNonTax
                                }, _toDisplayString(item.diff.nonTax), 11, _hoisted_41),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right tooltip-cell", getDiffClass(item.diff.companyIns, true)]),
                                  title: item.tooltip.diffCompanyIns
                                }, _toDisplayString(item.diff.companyIns), 11, _hoisted_42),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right tooltip-cell", getDiffClass(item.diff.retirement, true)]),
                                  title: item.tooltip.diffRetirement
                                }, _toDisplayString(item.diff.retirement), 11, _hoisted_43),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right tooltip-cell", getDiffClass(item.diff.netPay)]),
                                  title: item.tooltip.diffNetPay
                                }, _toDisplayString(item.diff.netPay), 11, _hoisted_44),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["saving-cell text-right font-bold tooltip-cell", getDiffClass(item.saving, true)]),
                                  title: item.tooltip.saving
                                }, _toDisplayString(item.saving), 11, _hoisted_45)
                              ], 2))
                            }), 128))
                          ]),
                          _createElementVNode("tfoot", null, [
                            _createElementVNode("tr", _hoisted_46, [
                              _createElementVNode("td", {
                                class: "sticky-col col-no font-bold",
                                colspan: hasServiceStartYm.value ? 4 : 3
                              }, "합계", 8, _hoisted_47),
                              _createElementVNode("td", _hoisted_48, _toDisplayString(totals.total), 1),
                              _createElementVNode("td", _hoisted_49, _toDisplayString(totals.before.nonTax), 1),
                              _createElementVNode("td", _hoisted_50, _toDisplayString(totals.before.companyIns), 1),
                              _createElementVNode("td", _hoisted_51, _toDisplayString(totals.before.retirement), 1),
                              _createElementVNode("td", _hoisted_52, _toDisplayString(totals.before.netPay), 1),
                              _createElementVNode("td", _hoisted_53, _toDisplayString(totals.after.nonTax), 1),
                              _createElementVNode("td", _hoisted_54, _toDisplayString(totals.after.companyIns), 1),
                              _createElementVNode("td", _hoisted_55, _toDisplayString(totals.after.retirement), 1),
                              _createElementVNode("td", _hoisted_56, _toDisplayString(totals.after.netPay), 1),
                              _createElementVNode("td", {
                                class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(totals.diff.nonTax)])
                              }, _toDisplayString(totals.diff.nonTax), 3),
                              _createElementVNode("td", {
                                class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(totals.diff.companyIns, true)])
                              }, _toDisplayString(totals.diff.companyIns), 3),
                              _createElementVNode("td", {
                                class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(totals.diff.retirement, true)])
                              }, _toDisplayString(totals.diff.retirement), 3),
                              _createElementVNode("td", {
                                class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(totals.diff.netPay)])
                              }, _toDisplayString(totals.diff.netPay), 3),
                              _createElementVNode("td", {
                                class: _normalizeClass(["saving-cell text-right font-bold", getDiffClass(totals.saving, true)])
                              }, _toDisplayString(totals.saving), 3)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "summary" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _hoisted_60,
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _createElementVNode("span", _hoisted_63, _toDisplayString(totals.total), 1)
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _hoisted_65,
                              _createElementVNode("span", _hoisted_66, _toDisplayString(totals.before.nonTax), 1)
                            ]),
                            _hoisted_67,
                            _createElementVNode("div", _hoisted_68, [
                              _hoisted_69,
                              _createElementVNode("span", _hoisted_70, _toDisplayString(totals.before.companyIns), 1)
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _hoisted_72,
                              _createElementVNode("span", _hoisted_73, _toDisplayString(totals.before.retirement), 1)
                            ]),
                            _hoisted_74,
                            _createElementVNode("div", _hoisted_75, [
                              _hoisted_76,
                              _createElementVNode("span", _hoisted_77, _toDisplayString(totals.before.netPay), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_78, [
                            _hoisted_79,
                            _createElementVNode("div", _hoisted_80, [
                              _hoisted_81,
                              _createElementVNode("span", _hoisted_82, _toDisplayString(totals.total), 1)
                            ]),
                            _createElementVNode("div", _hoisted_83, [
                              _hoisted_84,
                              _createElementVNode("span", _hoisted_85, _toDisplayString(totals.after.nonTax), 1)
                            ]),
                            _hoisted_86,
                            _createElementVNode("div", _hoisted_87, [
                              _hoisted_88,
                              _createElementVNode("span", _hoisted_89, _toDisplayString(totals.after.companyIns), 1)
                            ]),
                            _createElementVNode("div", _hoisted_90, [
                              _hoisted_91,
                              _createElementVNode("span", _hoisted_92, _toDisplayString(totals.after.retirement), 1)
                            ]),
                            _hoisted_93,
                            _createElementVNode("div", _hoisted_94, [
                              _hoisted_95,
                              _createElementVNode("span", _hoisted_96, _toDisplayString(totals.after.netPay), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            _hoisted_98,
                            _createElementVNode("div", _hoisted_99, [
                              _hoisted_100,
                              _createElementVNode("span", _hoisted_101, _toDisplayString(activeEmployeeCount.value) + "명", 1)
                            ]),
                            _hoisted_102,
                            _createElementVNode("div", _hoisted_103, [
                              _hoisted_104,
                              _createElementVNode("span", {
                                class: _normalizeClass(["value", getDiffClass(totals.diff.companyIns, true)])
                              }, _toDisplayString(totals.diff.companyIns), 3)
                            ]),
                            _createElementVNode("div", _hoisted_105, [
                              _hoisted_106,
                              _createElementVNode("span", {
                                class: _normalizeClass(["value", getDiffClass(totals.diff.retirement, true)])
                              }, _toDisplayString(totals.diff.retirement), 3)
                            ]),
                            _hoisted_107,
                            _createElementVNode("div", _hoisted_108, [
                              _hoisted_109,
                              _createElementVNode("span", {
                                class: _normalizeClass(["value large", getDiffClass(totals.saving, true)])
                              }, _toDisplayString(totals.saving), 3)
                            ]),
                            _createElementVNode("div", _hoisted_110, [
                              _hoisted_111,
                              _createElementVNode("span", {
                                class: _normalizeClass(["value", getDiffClass(totals.saving, true)])
                              }, _toDisplayString(totals.yearSaving), 3)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_112, _hoisted_114)),
        _createElementVNode("div", _hoisted_115, [
          _createVNode(_component_v_btn, {
            class: "cancelRegistBtn",
            onClick: closeDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode("닫기")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})